export const paymentRequest = 'paymentRequest';
export const GET_PAYMENTS_DATA = 'GET_PAYMENTS_DATA';
export const RESET_PAYMENT_ENCRYPTED_DATA = 'RESET_PAYMENT_ENCRYPTED_DATA';
